export const DOMAIN = process.env.NODE_ENV === "production" ? "" : "http://localhost:8000";